import { useCallback } from "react";

import { formatText } from "../utils/analytics";

export interface DataLayerEvent {
  event: string;
  [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

export function useDataLayer() {
  const pushEvent = useCallback(function <T extends DataLayerEvent>(
    { event, ...rest }: T,
    preserveKeys?: Array<keyof T>
  ) {
    if (typeof window !== "undefined" && process.env.GATSBY_GTAG_ID) {
      window.dataLayer = window.dataLayer ?? [];

      const eventToPush: DataLayerEvent = { event };
      for (let key of Object.keys(rest)) {
        let value = rest[key] ?? "";
        eventToPush[key] =
          !preserveKeys?.includes(key) && typeof value === "string" ? formatText(value) : value;
      }

      window.dataLayer.push(eventToPush);
    }
  }, []);

  return {
    pushEvent,
  };
}
